export var smaReview = {
  msgErrorSenderId: 'Вы не можете оставить отзыв по этой заявке',
  // не хватает фразы типа "Остались вопросы? Пожалуйста, обратитесь в службу поддержки" со ссылкой на форму отправки запроса
  msgClaimNumber: 'Номер',
  msgClaimName: 'Наименование',
  msgYourReview: 'Пожалуйста, оставьте свой отзыв',
  msgSend: 'Отправить',
  msgWarningEmptyReview: 'Вы уверены, что хотите отправить оценку без подробного отзыва?',
  msgNoReviews: 'Пока нет отзывов'
};